<template>
  <div class="page-root tools-vin-root">
    <div class="tools-banner-wrapper">
      <div class="tools-banner">
        <div class="text">
          <div class="zh">VIN码精准评估</div>
          <div class="en">VIN CODE PRECISE POSITIONING MODEL</div>
          <div class="small">解决通过vin码识别车型的关键问题，能对品牌、车系、车型精准识别并进行精准评估<br>真正提高业务效率</div>
          <div class="line"></div>
        </div>
        <div class="box"></div>
        <div class="img">
          <img src="@/assets/tools-vin@2x.png" />
        </div>
        <div class="hidden-md-and-up" style="color: #000; margin-top: 10px; font-size: 13px" @click="search('sim')">
          查看报告样例 >
        </div>
      </div>
    </div>
    <div class="tabs-wrapper">
      <div class="title">VIN精准评估</div>
      <div class="list-bar">
        <div class="list" v-show="!inputShow" >
          <el-input placeholder="请输入17位VIN码" v-model="vin" class="input1"> </el-input>
          <el-input placeholder="验证码" v-model="msgCode" class="input2"> </el-input>
          <img width="100" height="40" :src="'data:image/jpeg;base64,' + captchas.img" @click="toCaptchas" />
        </div>
        <div class="list" v-show="inputShow">
          <el-input placeholder="请输入17位VIN码" v-model="vin" class="input3"> </el-input>
          <el-input placeholder="请输入手机号" v-model="phone" class="input3"> </el-input>
          <el-input placeholder="短信验证码" v-model="msgCode" class="input3">
            <template slot="append">
              <el-button  @click="handleSendCode" :disabled="isCounting">{{ buttonText }}</el-button>
            </template>
          </el-input>
        </div>
        <div class="butt hidden-md-and-down">
          <div @click="search">开始查询</div>
          <div @click="search('sim')">查看报告样例 ></div>
        </div>
        <div class="butt-sm hidden-md-and-up">
          <div @click="search">开始查询</div>
        </div>
      </div>
    </div>
    <div class="cars-wrapper-sm">
      <div class="car-tabs">
        <div class="car-list">
          <img class="img" src="./assets/自有完善的车型库.svg" />
          <div>
            <div class="title">精准识别服务</div>
            <div class="data">解决车辆识别和定型的关键问题，能对车辆进行准确的识别，是开展各项业务的根基</div>
          </div>
        </div>
        <div class="car-list">
          <img class="img" src="./assets/快速便捷查询.svg" />
          <div>
            <div class="title">快速查询服务</div>
            <div class="data">使用VIN查询快速确定品牌、车系、车型等重要车辆信息，省去大量人工和时间</div>
          </div>
        </div>
        <div class="car-list">
          <img class="img" src="./assets/车辆精准定位.svg" />
          <div>
            <div class="title">高效评估服务</div>
            <div class="data">依托海量大数据服务，结合专业评估团队和智能评估模型，提供高效精准的查询和评估服务</div>
          </div>
        </div>
      </div>
    </div>
    <div class="cars-wrapper">
      <div class="car-tabs">
        <div class="car-list">
          <img class="img" src="./assets/自有完善的车型库.svg" />
          <div class="title">精准识别服务</div>
          <div class="data">解决车辆识别和定型的关键问题，能对车辆进行准确的识别，是开展各项业务的根基</div>
        </div>
        <div class="car-list">
          <img class="img" src="./assets/快速便捷查询.svg" />
          <div class="title">快速查询服务</div>
          <div class="data">使用VIN查询快速确定品牌、车系、车型等重要车辆信息，省去大量人工和时间</div>
        </div>
        <div class="car-list">
          <img class="img" src="./assets/车辆精准定位.svg" />
          <div class="title">高效评估服务</div>
          <div class="data">依托海量大数据服务，结合专业评估团队和智能评估模型，提供高效精准的查询和评估服务</div>
        </div>
      </div>
    </div>
    <!-- 弹窗内显示进度条 -->
    <el-dialog title="估值报告加载中..." :visible.sync="dialogTableVisible" width="40%" top="40vh" :show-close="false">
      <el-progress :text-inside="true" :stroke-width="20" :percentage="percentage" status="success"></el-progress>
    </el-dialog>
  </div>
</template>
<script>
import './styles/mobile.scss';
import './styles/pc/pc.scss';
import { get } from '@/utils/axios';
import json from './data.json';
export default {
  methods: {
    handleSendCode() {
      if (this.vin.length!=17) {
          this.$message({
            message: '请输入完整17位VIN码 ！',
            type: 'warning',
          });
          return
        }
        if (!this.phone || this.phone.length != 11) {
          this.$message({
            message: '请输入正确手机号 ！',
            type: 'warning',
          });
          return
        }
      if (!this.isCounting) {
        // 发送验证码的逻辑
        // 这里可以调用发送验证码的后端接口，发送手机号并开始倒计时
        this.isCounting = true;
        this.buttonText = this.count + 's后重新发送';
        var timer = setInterval(() => {
          this.count--;
          this.buttonText = this.count + 's后重新发送';
          if (this.count <= 0) {
            clearInterval(timer);
            this.buttonText = '获取验证码';
            this.isCounting = false;
            this.count = 30; // 重置倒计时时间
          }
        }, 1000);
        get(`/sms/send?phone=${this.phone}`).then((res) => {
          console.log(res)
        });
      }
    },
    //开始查询
    search(params) {
      if (params == 'sim') {
        this.$router.push({
          name: 'Tools-vinResult',
          query: {
            id: this.order.id,
            vin: this.order.vin,
            orderNo: this.order.orderNo,
            brand: this.order.brand,
            series: this.order.series,
            vehicleType: this.order.vehicleType,
            createTime: this.order.createTime,
            jsonResult: this.order.jsonResult
          },
        });
      } else {
        if (this.vin.length!=17) {
          this.$message({
            message: '请输入完整17位VIN码 ！',
            type: 'warning',
          });
          return
        }
        if (this.inputShow){
          if (!this.phone || this.phone.length != 11) {
            this.$message({
              message: '请输入正确手机号 ！',
              type: 'warning',
            });
            return
          }
        }
        if (!this.msgCode) {
          this.$message({
            message: '请输入验证码 ！',
            type: 'warning',
          });
          return
        }
        this.openDialog()
        get(
          `/system/vin/select?vin=${this.vin}&phone=${this.phone}&msgCode=${this.msgCode}&uuid=${this.uuid}`
        ).then((res) => {
          if (res.code == 200) {
            this.closeDialog()
            let data = res.data
            this.$router.push({
              name: 'Tools-vinResult',
              query: {
                id: data.id,
                vin: data.vin,
                orderNo: data.orderNo,
                brand: data.brand,
                series: data.series,
                vehicleType: data.vehicleType,
                createTime: data.createTime,
                jsonResult: data.jsonResult
              },
            });
          } else {
            this.closeDialog()
            this.$message.error(res.msg);
          }
        });
      }
    },
    selectTodayCount(){
      get(`/system/vin/selectTodayCount`).then((res) => {
        if (res.code == 200) {
          this.inputShow = res.data
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //获取验证码
    toCaptchas() {
      get('/captchas').then((res) => {
        this.captchas = res;
        this.uuid = res.uuid;
      });
    },
    openDialog(){
      this.dialogTableVisible = true
      let percentage = 0;
      const interval = setInterval(() => {
        if (percentage < 100) {
          percentage += 20;
          if (percentage >= 100) {
            percentage = 99;
          }
          // 更新进度条
          this.percentage = percentage;
        } else {
          // 如果进度达到100%，清除定时器
          clearInterval(interval);
        }
      }, 1000);
    },
    closeDialog(){
      this.percentage = 100;
      this.dialogTableVisible = false
    },
  },
  mounted() {
    this.selectTodayCount();
    this.toCaptchas();
  },
  data() {
    return {
      show: false,
      options: [], //手机端车型list
      vin: '', //vin
      phone: '', //手机号
      msgCode: '', //验证码
      isCounting: false, // 用于控制按钮是否可点击
      buttonText: '获取验证码', // 按钮上的文字内容
      count: 30, // 倒计时时间
      captchas: {}, //验证码返回值
      uuid: '',
      inputShow: false,
      dialogTableVisible: false,
      percentage: 10,
      order:{
        id:1,
        orderNo: "2024011212345",
        vin:"LFV3A28W5J*******",
        brand: "奥迪",
        series: "奥迪A4L",
        vehicleType:"奥迪A4L-2.0T-A/MT-45TFSI-30周年quattro个性运动版DSG双离合(国Ⅴ)",
        createTime: "2024-01-12 10:58:01",
        jsonResult: "{\"Detail\":{\"Basic\":{\"Country\":\"中国\",\"Emission\":\"国Ⅴ\",\"ModelID\":\"199188\",\"BrandType\":\"中级轿车\",\"EndDate\":\"2018-12-31\",\"ProductionState\":\"停产\",\"SeriesType\":\"中级轿车\",\"Warranty\":\"3年/10万公里\"},\"Body\":{\"Doors\":\"4\",\"FrontTrack\":\"0\",\"FuelTank\":\"58\",\"Height\":\"1432\",\"Length\":\"4818\",\"MaximumTrunk\":\"0\",\"MinimumGroundClearance\":\"107.0000\",\"RearTrack\":\"0\",\"Seating\":\"5\",\"Trunk\":\"424\",\"Weight\":\"1645\",\"WheelBase\":\"2908\",\"Width\":\"1843\",\"ApproachAngle\":\"0.0000\",\"CarBodyForm\":\"4门5座三厢车\",\"DepartureAngle\":\"0.0000\",\"DragCoefficient\":\"0.0000\",\"FrontSuspensionLength\":\"0\",\"HoodForm\":\"\",\"HoodOpening\":\"\",\"MaximumMass\":\"2110\",\"MinimumTurningDiameter\":\"0.0000\",\"RearSuspensionLength\":\"0\",\"RoofForm\":\"硬顶\"},\"Chassis\":{\"DriveHubDiameter\":\"18\",\"DriveTireHeightAspectRatio\":\"40\",\"DriveTireWidth\":\"245\",\"DrivingMethod\":\"四驱\",\"FWDMethod\":\"全时四驱\",\"FrontBrake\":\"通风盘\",\"FrontSuspension\":\"五连杆式独立悬架\",\"FrontTireSize\":\"245/40 R18\",\"PowerSteering\":\"电动助力\",\"RearBrake\":\"盘式\",\"RearSuspension\":\"五连杆式独立悬架\",\"RearTireSize\":\"245/40 R18\",\"SpareTire\":\"非全尺寸备胎\",\"Transmission\":\"7档 手自一体\",\"FrontHubMaterial\":\"\",\"GearMode\":\"地排\",\"RearHubMaterial\":\"\",\"SpareTireHubMaterial\":\"\",\"SpareTireNum\":\"1\",\"SpareTireNumSize\":\"\",\"SteeringSystem\":\"\"},\"Driving\":{\"Acceleration\":\"5.9000\",\"BrakingDistance\":\"0.0000\",\"MaximumGradability\":\"\",\"MaximumSpeed\":\"250\"},\"ElectricMotor\":{\"BatteryCapacity\":\"\",\"ElectromotorModel\":\"\",\"HyBridType\":\"\",\"MaximumMileage\":\"0\",\"MaximumPower\":\"0.00\",\"PeakTorque\":\"0.00\",\"battery_type\":\"\",\"charging_interval\":\"\",\"is_electrical_shift\":\"\",\"motor_after_max_power\":\"\",\"motor_after_max_torque\":\"\",\"motor_battery_brand\":\"\",\"motor_battery_cell_manufacturer\":\"\",\"motor_battery_charge_rate\":\"\",\"motor_battery_count_kg\":\"\",\"motor_battery_density\":\"\",\"motor_battery_slow_charge_hours\":\"\",\"motor_battery_warranty_km\":\"\",\"motor_battery_warranty_year\":\"\",\"motor_befor_max_power\":\"\",\"motor_befor_max_torque\":\"\",\"motor_constant_speed_km\":\"\",\"motor_hundred_km_kwh\":\"\",\"motor_layout\":\"\",\"motor_num\":\"\",\"motor_production_company\":\"\",\"motor_system_synthesis_power\":\"\",\"motor_system_synthesis_torque\":\"\",\"motor_the_type\":\"\"},\"Engine\":{\"AirIntake\":\"涡轮增压\",\"Compression\":\"0.0000\",\"CylinderBlock\":\"铸铁\",\"CylinderCover\":\"铝合金\",\"CylinderDiameter\":\"0.0000\",\"CylinderNum\":\"4\",\"EngineModel\":\"CWP\",\"EngineStroke\":\"0.0000\",\"EngineType\":\"直列\",\"Exhaust\":\"1984\",\"FuelSupplyMode\":\"混合喷射\",\"FuelType\":\"无铅汽油95#\",\"MaximumPower\":\"185(252)/5000-6000\",\"PeakTorque\":\"370/1600-4500\",\"ValveNum\":\"4\",\"AdmissionGear\":\"DOHC\",\"ComprehensiveFuelConsumption\":\"6.9000\",\"CoolingSystem\":\"水冷\",\"EngineDescription\":\"\",\"EngineDirection\":\"横向\",\"EngineImportantTechnology\":\"\",\"EngineManufacturer\":\"\",\"EnginePosition\":\"\",\"LitrePower\":\"93.2500\",\"MaximumPowerKW\":\"185.0000\",\"MaximumPowerPS\":\"252.0000\",\"MaximumPowerRPM\":\"5000-6000\"},\"Truck\":{\"AxleNum\":\"0\",\"FrontAxleLoad\":\"0\",\"LoadingSpaceHeight\":\"0\",\"LoadingSpaceLength\":\"0\",\"LoadingSpaceType\":\"\",\"LoadingSpaceWidth\":\"0\",\"MaxGrossMass\":\"0\",\"RearAxleLoad\":\"0\",\"SprinNum\":\"\"}},\"Model\":{\"Displacement\":\"2.0\",\"ID\":\"199188\",\"Name\":\"奥迪A4L-2.0T-A/MT-45TFSI-30周年quattro个性运动版DSG双离合(国Ⅴ)\",\"Price\":\"36.7000\",\"TransmissionType\":\"7档 手自一体\",\"VersionYear\":\"2018\",\"ProductionYear\":\"2018\",\"VersionDate\":\"201709\",\"is_new_energy\":\"0\",\"MergeID\":\"199188\"},\"NewPrice\":{\"ModelID\":\"199188\",\"Price\":\"29.36\"},\"UsedPrice\":{\"BuyPrice\":\"16.13\",\"ModelID\":\"199188\",\"SellPrice\":\"17.69\"},\"Brand\":\"奥迪\",\"Color\":\"朱鹭白\",\"EngineNo\":\"031714\",\"GB\":\"FV7203BBQBG\",\"Mfrs\":\"一汽奥迪\",\"ProductionDate\":\"2018-08-18\",\"Series\":\"奥迪A4L\"}"
      },
    };
  },
};
</script>
